import { Jobs } from "@/components/jobs";

const Home = () => <Jobs />

export default Home;